import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import apiRequest from '../../lib/apiRequest';
import logger from '../../lib/logger';

const VerifyPage = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyAccount = async () => {
      try {
        // Extract token & email from query params
        const token = searchParams.get('token');
        const email = searchParams.get('email');
        if (!token || !email) {
          setError('Missing token or email in the URL.');
          setLoading(false);
          return;
        }

        // Call your backend verify endpoint
        // e.g. GET /v0/api/users/verify?token=xxx&email=yyy
        const res = await apiRequest.post('/auth/verify', {
        token, email 
        });

        // If successful, show a success message
        setMessage(res.data.message || 'Account verified successfully!');
      } catch (err) {
        logger.error('Verification error:', err);
        if (err.response && err.response.data) {
          setError(err.response.data.message || 'Verification failed.');
        } else {
          setError('Verification failed. Please try again later.');
        }
      } finally {
        setLoading(false);
      }
    };

    verifyAccount();
  }, [searchParams]);

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Verifying your account...</div>;
  }

  if (error) {
    return <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>{error}</div>;
  }

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>{message}</h2>
      <p>Your account is now verified. You may <a href="/login">login</a> and enjoy the site!</p>
    </div>
  );
};

export default VerifyPage;
